<template>
  <div v-if="chartShow">
    <PieChart class="max-width-450" :chart-data="chartLevelData" />
  </div>
</template>

<script>
  import PieChart from '../charts/Pie.js'

  export default {
    components: { PieChart },
    props: ['data'],
    data() {
      return {
        chartShow: false,

        chartLevelData: {
          labels: [],
          datasets: [
            {
              label: 'Level',
              data: [],
              backgroundColor: [],
            },
          ],
        },
      }
    },
    methods: {
      async readLevelChart() {
        let levels = this.data.level
        for (let index = 0; index < levels.length; index++) {
          let level = levels[index]
          this.chartLevelData.labels.push(level._id)
          this.chartLevelData.datasets[0].data.push(level.count)
          if (level._id === 'normal') {
            this.chartLevelData.datasets[0].backgroundColor.push(
              'rgb(180, 60, 60)'
            )
          }
          if (level._id === 'familial') {
            this.chartLevelData.datasets[0].backgroundColor.push(
              'rgb(60, 60, 255)'
            )
          }
          if (level._id === 'enfant') {
            this.chartLevelData.datasets[0].backgroundColor.push(
              'rgb(60, 255, 60)'
            )
          }
        }
        this.chartShow = true
      },
    },
    mounted() {
      this.readLevelChart()
    },
  }
</script>

<style scoped>
  .max-width-450 {
    max-width: 450px;
  }
</style>
